export const SET_SITE = 'SET_SITE';

export const setSite = (site) => {
  return {
    type: SET_SITE,
    site: site
  };
};